module.exports = __webpack_public_path__ + "img/picture_2.6e70886a.png";